import {
  CloseButton,
  ModalWrapper,
  ModalTitle,
  ModalDesctiption,
  ButtonWrapper,
  ControlButton,
  CloseButtonWrapper,
} from './styles';

const customStyles = {
  overlay: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    backgroundColor: 'rgba(0, 0, 0, 0.35)',
  },
};
function ModalView({
  isOpen,
  onCloseBtn,
  onBtnLeftClick,
  onBtnRightClick,
  title,
  description,
  leftBtnTitle,
  rightBtnTitle,
  disableBtns = false,
}) {
  return (
    <ModalWrapper
      isOpen={isOpen}
      onRequestClose={onCloseBtn}
      contentLabel='Yes or No dialog'
      style={customStyles}
      shouldCloseOnEsc={false}>
      <CloseButtonWrapper>
        <CloseButton onClick={onCloseBtn} />
      </CloseButtonWrapper>
      <ModalTitle>{title}</ModalTitle>
      <ModalDesctiption>{description}</ModalDesctiption>
      <ButtonWrapper>
        <ControlButton
          title={leftBtnTitle}
          onClick={onBtnLeftClick}
          disabled={disableBtns}
        />
        <ControlButton
          title={rightBtnTitle}
          onClick={onBtnRightClick}
          disabled={disableBtns}
        />
      </ButtonWrapper>
    </ModalWrapper>
  );
}

export default ModalView;
